'use client';

import { useEffect, useState } from 'react';

import { Activity } from '@website/services/activities.service';

interface UseSelectedActivityOptions {
  activities: Activity[] | undefined;
  paramName?: string;
}

export function useSelectedActivity({ activities }: UseSelectedActivityOptions) {
  const [selectedActivityId, setSelectedActivityId] = useState<string | null>(null);
  const [selectedActivity, setSelectedActivity] = useState<Activity | null>(null);

  // Sync selected activity with activities data and URL param
  useEffect(() => {
    if (!activities?.length) {
      setSelectedActivity(null);
      return;
    }

    if (selectedActivityId) {
      const activity = activities.find((a) => a.id === selectedActivityId);
      setSelectedActivity(activity || null);
    } else {
      setSelectedActivity(null);
    }
  }, [activities, selectedActivityId]);

  const selectActivity = (activity: Activity | null) => {
    setSelectedActivityId(activity?.id || null);
  };

  const toggleActivity = (activity: Activity) => {
    if (selectedActivity?.id === activity.id) {
      setSelectedActivityId(null);
    } else {
      setSelectedActivityId(activity.id);
    }
  };

  const clearSelection = () => {
    setSelectedActivityId(null);
  };

  return {
    selectedActivity,
    selectedActivityId,
    selectActivity,
    toggleActivity,
    clearSelection,
    isSelected: (activity: Activity) => selectedActivity?.id === activity.id
  };
}
